export default {"src":"/apac/_next/static/media/structure_search_icon_bold.be1b34f1.svg","height":19,"width":30,"blurWidth":0,"blurHeight":0};